export const COMMENTS_ORDER_BY = "coral:localState:commentsOrderBy";
